import { prepareForSlot } from '@mui/base'
import { clsx } from 'clsx'
import { type ComponentProps, type JSX } from 'react'

const SliderTrackSlot = prepareForSlot(function SliderTrack(
  props: ComponentProps<'span'>,
): JSX.Element {
  const { className, ...rest } = props

  return <span className={clsx('slider__track', className)} {...rest} />
})

export const SliderTrack = SliderTrackSlot
